/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { AppDb } from "./AppDb";
import { IScheduleFiltersDatabase } from "./IScheduleFiltersDatabase";
import { IScheduleFiltersEntity } from "sh-models";

/**
 * The Schedule filters database accessor.
 */
export class ScheduleFiltersDatabase implements IScheduleFiltersDatabase {
    private db: AppDb;

    /**
     * Constructor for ScheduleFiltersDatabase.
     * @param db The database.
     */
    constructor(db: AppDb) {
        this.db = db;
    }

    /**
     * Fetch the schedule filters.
     * @param teamId The team id.
     * @returns The schedule filters.
     */
    public async getScheduleFilters(teamId: string): Promise<IScheduleFiltersEntity> {
        if (!this.db?.scheduleFilters) {
            return undefined;
        }

        const scheduleFilters = await this.db.scheduleFilters.get(teamId);
        return scheduleFilters;
    }

    /**
     * Set schedule filters in Database.
     * @param scheduleFilters The schedule filters.
     */
    public async setScheduleFilters(scheduleFilters: IScheduleFiltersEntity): Promise<void> {
        if (!this.db) {
            return;
        }

        await this.db.scheduleFilters.put(scheduleFilters);
    }
}